import styled from 'styled-components'
import { IconButton } from '../IconButton/IconButton'

export const QuickAddToCartButtonBackground = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2.9rem;
  height: 2.9rem;
`

export const QuickAddToCartButtonIcon = styled(IconButton)`
  z-index: 1;
  position: absolute;
  top: 49%;
  transform: translate(-50%, -50%);
  left: 50%;

  .cls-1 {
    stroke: ${({ theme }) => theme.colors.text.primary} !important;
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
`
